import { getFromCookie } from './cookie'
import { waitFor } from './waitFor'

const labelForFindCategory: Set<string> = new Set(['performance', 'experience'])

const ensureTcPrivacyIsDefined = () =>
  waitFor(() => typeof globalThis.window.tC?.privacy?.getConsent === 'function')

/** Rejette si l'outil de consentement (`window.tC`) n'est pas chargé dans le délai imparti. */
export const userConsentPerformances = async () =>
  await ensureTcPrivacyIsDefined().then(() =>
    isConsentForPerformanceGranted(globalThis.window.tC.privacy.getConsent()),
  )

export const isConsentForPerformanceGranted = (consent: consentTc): boolean => {
  if (consent.consent.status === 'all-on') {
    return true
  }
  if (consent.consent.status === 'mixed') {
    const categories = globalThis.window.tC.privacy.allCategories
    const performanceCategory = categories.find((category) =>
      labelForFindCategory.has(category.label.toLowerCase()),
    )
    if (performanceCategory) {
      const categoryConsentStat =
        globalThis.window.tC.privacy.getConsent().consent.categories[performanceCategory.id]
      if (typeof categoryConsentStat === 'boolean') {
        return categoryConsentStat
      } else {
        return categoryConsentStat === 'on'
      }
    }
  }
  return false
}

export const getAllCategoriesWithConsent = (): number[] => {
  const tcPrivacy = getFromCookie('TC_PRIVACY')
  if (!tcPrivacy) return []

  // .at() est ES2022, non supporté sur Safari/iOS < 15.4 (MPT-20776) :
  // index positif simple, remplacé par un accès direct par index
  const consents = tcPrivacy.split('@')[2]
  if (!consents) return []
  if (consents.includes(',')) {
    return consents.split(',').map((consent) => Number.parseInt(consent, 10))
  }
  return [Number.parseInt(consents, 10)]
}
